<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" class="scaling-svg">
      <g id="Icon_calendar" transform="translate(-2 -2)">
        <g id="Icon_calendar-2" data-name="Icon_calendar" transform="translate(1.75 1.75)">
          <path id="Path" d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(2.333 3.5)" />
          <path
            id="Path-2"
            data-name="Path"
            d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z"
            transform="translate(2.333 5.833)"
          />
          <path
            id="Path-3"
            data-name="Path"
            d="M.583,0a.583.583,0,1,0,.583.583A.583.583,0,0,0,.583,0Z"
            transform="translate(4.667 3.5)"
          />
          <path
            id="Path-4"
            data-name="Path"
            d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z"
            transform="translate(7 3.5)"
          />
          <path
            id="Shape"
            d="M9.778,11H1.222A1.223,1.223,0,0,1,0,9.778V2.444A1.223,1.223,0,0,1,1.222,1.222H2.444V.611a.611.611,0,0,1,1.223,0v.611H7.333V.611a.611.611,0,0,1,1.223,0v.611H9.778A1.223,1.223,0,0,1,11,2.444V9.778A1.223,1.223,0,0,1,9.778,11ZM1.833,2.444a.612.612,0,0,0-.611.612V9.167a.612.612,0,0,0,.611.611H9.167a.612.612,0,0,0,.611-.611V3.056a.612.612,0,0,0-.611-.612Z"
            transform="translate(0.25 0.25)"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BookingsIcon extends Vue {}
</script>

<style>
</style>
